
<nz-layout style="height: 100%;">
  <nz-content>
    <router-outlet></router-outlet>
  </nz-content>

  <nz-footer class="uiFooter" [class.uiFooter--hidden]="!showFooter">
    <div class="uiFooter__inner">
      <div class="uiFooter__left">
        <span class="uiFooter__copy">
          v{{ g.appVersion }} &middot; &copy;2026 Amajor Società Benefit S.P.A.
        </span>
        <span class="uiFooter__contacts">
          <a class="footerLink" href="mailto:app@amajorsb.com" aria-label="Email">
            <i nz-icon nzType="mail" nzTheme="fill"></i><span class="uiFooter__linkText">app@amajorsb.com</span>
          </a>
          <a class="footerLink" href="tel:+390499700548" aria-label="Telefono">
            <i nz-icon nzType="phone" nzTheme="fill"></i><span class="uiFooter__linkText">049 9700548</span>
          </a>
        </span>
        <span class="uiFooter__legal">
          <a class="footerLink cky-banner-element"
             href="https://api.avacy.eu/ocalab/cookiepolicy/11/it">Cookie Policy</a>
          <span class="uiFooter__sep">|</span>
          <a class="footerLink"
             href="https://www.amajorsb.com/wp-content/uploads/2025/05/02-Informativa-Online-Generale-Sito-Web-Privacy-Policy-3F-O320250G.pdf"
             target="_blank">Privacy Policy</a>
          <span class="uiFooter__sep">|</span>
          <a class="footerLink" href="javascript:void(0)" (click)="openCookiePreferences()">
            Preferenze Cookie
          </a>
        </span>
      </div>
      <div class="uiFooter__right">Powered by Amajor</div>
    </div>
  </nz-footer>

  <!-- FAB globale (azioni contestuali impostate dalle singole pagine via FabService) -->
  <app-fab></app-fab>
</nz-layout>
